/**
 *
 * ChipCheckBoxGroup
 *
 */
import {
  FormControl,
  FormGroup,
  FormHelperText,
  FormLabel,
  styled,
} from '@material-ui/core';
import * as React from 'react';
import { inputLabelXS } from 'styles/typography/bookitTypography';
import { BookitChipWithCheck } from '.';
import { CheckEntity } from '../CheckBoxGroup';
import FormControlLabel from '../Forms/FormControls/FormControlLabel';

export interface ChipCheckBoxGroupProps {
  options: CheckEntity[];
  value?: CheckEntity[];
  className?: string;
  onChange?: (
    value: CheckEntity,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  id: string;
  //formik
  name?: string;
  error?: boolean;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  helperText?: string;
  info?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  margin?: 'none' | 'dense' | 'normal';
  isRow?: boolean;
  style?: React.CSSProperties;
}

export function ChipCheckBoxGroup({
  name,
  id,
  value,
  options,
  onChange,
  label,
  required,
  helperText,
  disabled,
  fullWidth,
  margin,
  error,
  size,
  isRow,
  style,
  ...props
}: ChipCheckBoxGroupProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = {
      Id: parseInt(event.target.id),
      Name: event.target.name,
      checked: event.target.checked,
      disabled: event.target.disabled,
    } as CheckEntity;
    if (onChange !== undefined) {
      onChange(value, event);
    }
  };
  return (
    <FormControl
      required={required}
      error={error}
      component="fieldset"
      name={name}
      margin={margin}
      id={id}
      fullWidth={fullWidth}
      style={{
        border: '1px solid #CDD5DF',
        borderRadius: '6px',
        minHeight: '48px',
        backgroundColor: '#ffffffcc',
        paddingBlock: '8px',
        paddingInline: '6px',
        ...style,
      }}
    >
      <StyledFormLabel>{label}</StyledFormLabel>
      <FormGroup
        row={isRow}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          gap: '6px',
          //maxWidth: '260px',
        }}
      >
        {options.map((item, index) => (
          <FormControlLabel
            value={item}
            // key={`control_${item.Id}`}
            disabled={disabled || item.disabled}
            style={{ width: '260px', margin: 0 }}
            label=""
            control={
              <BookitChipWithCheck
                key={`chip_${item.Id}`}
                checkid={item.Id.toString()}
                label={item.Name}
                checked={item.checked}
                checkname={item.Name}
                disabled={item.disabled}
                info={item.Name.length > 24 ? item.Name : undefined}
                onChange={handleChange}
                size="medium"
                color="primary"
              />
            }
          />
        ))}
      </FormGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
  color: theme.palette.common.graySubtitle,
  inputLabelXS,
  '.Mui-focused &': {
    color: theme.palette.common.graySubtitle,
  },
}));
